import { gql } from '@apollo/client';
const UPDATE_PRODUCT_CONTINENT = gql `
  mutation UpdateProductContinent(
    $productContinentId: ID!
    $name: String!
    $description: String
    $thumbnail: String
  ) {
    updateProductContinent(
      productContinentId: $productContinentId
      name: $name
      description: $description
      thumbnail: $thumbnail
    ) {
      productContinent {
        id
        name
        description
        thumbnail
      }
    }
  }
`;
export default UPDATE_PRODUCT_CONTINENT;
